import React, { createContext, useState, useEffect } from 'react';
import firebase, { db } from '../firebase/base';

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    firebase.auth().onAuthStateChanged(setCurrentUser);
    if (currentUser) {
      const userRef = db.collection('users').doc(currentUser.uid);
      userRef
        .get()
        .then(doc => {
          if (!doc.exists) {
          } else {
            setUserProfile(doc.data());
          }
        })
        .catch(err => {
          console.log('Error getting document', err);
        });
    } else {
      setUserProfile(null);
    }
  }, [currentUser]);
  return (
    <AuthContext.Provider
      value={{
        currentUser,
        userProfile
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
